<template>
  <div class="center_conten personal_order">
    <div class="per_or_head_con" id="per_or_head_con">
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" class="be_usable active">
          <a href="#" aria-controls="be_usable" role="tab"
             data-toggle="tab" aria-expanded="false">中国出发航线</a>
        </li>
        <li role="presentation" class="used  external">
          <a
              href="/Rccl.Campaign/RedirectToTui?redirectUrl=https://www.rclrow.com/UserCenter/OrderRecord"
              aria-controls="used" role="tab" aria-expanded="true">
            海外出发航线
          </a>
        </li>
      </ul>
      <router-link id="goToBookingSearch" class="searchTooltip" to="/Rccl.Booking/Booking/BookingSearch">
        查询电话订单 &gt;
      </router-link>
      <b-tooltip target="goToBookingSearch" triggers="hover" placement="top" :boundary="'.per_or_head_con'"
                 :container="'per_or_head_con'" :fallback-placement="['top']">
        若您通过电话客服下单，可通过此处，将线下订单同步到个人中心
      </b-tooltip>
      <div class="fav_search_con">
        <input class="fav_input" type="text" id="searchBookingIdInput" ref="searchBookingIdInput" placeholder="请输入订单号查询">
        <img class="search_icon order_search" @click="onSearchBookingChanged"
             src="https://resource.rcclchina.com.cn/personalCenter/search-icon.png">
      </div>
    </div>
    <div class="tab-content">
      <div role="tabpanel" class="tab-pane coupon_modal_bd active" id="used">
        <div class="ord_stu_con">
          <div class="stu_btn" :class="{ checked: status=='all'}" data-row="ord_all" @click="onTabChanged('all')"><span>全部订单</span></div>
          <div class="stu_btn" :class="{ checked: status=='noPaid'}" @click="onTabChanged('noPaid')"><span>待付款订单</span>
            <i class="orderRecord-tab-badge" v-if="pageData.noPaid.length > 0">{{pageData.noPaid.length}}</i>
          </div>
          <div class="stu_btn" :class="{ checked: status=='paid'}" @click="onTabChanged('paid')"><span>已付款订单</span></div>
          <div class="stu_tip">
            <p>请尽快补全剩余款项，开启您的海洋之旅吧</p>
            <p class="stu_tip_small">您可使用订单号、航次、乘客信息进行关联预订、预订行前订产品、查看和修改订单信息等</p>
          </div>
        </div>
        <!-- 订单列表标题 -->
        <div class="ord_title_con">
          <div class="ord_title line_w">航线信息</div>
          <div class="ord_title passengers_w common-tac">乘客信息</div>
          <div class="ord_title ship_w">游轮往返</div>
          <div class="ord_title money_w">订单金额</div>
          <div class="ord_title operation_w">状态/操作</div>
        </div>
        <!---订单列表-->
        <div class="ord_row ord_all">
          <div class="no_booking_tips" v-show="currentBookings.length == 0 && isFinishLoading">您还没有相关订单哦</div>
          <BookingListItem
              v-for="(booking, i) in currentBookings" :key="('booking_'+i)"
              :booking="booking"
              :selectedBooking="selectedBooking"
              :selectedOpenBooking="selectedOpenBooking"
              :onConnectRoomClicked="showConnectRoom"
              :onQiaohuRoomClicked="showQiaohuPopup"
              :onStarrySkyRoomClicked="showStarrySkyPopup"
              :onCustomThemeRoomClicked="showCustomThemePopup"
              :onOpenBookingSelected="onOpenBookingSelected"
              :onBookingSelected="onBookingSelected"
              :isShowSelector="status=='noPaid'"
              :orderItem="booking"
              @showInvoiceList="showInvoiceList"
              @showWxQrCode="showWxQrCode(booking)"
          />
        </div>
        <!---合并支付-->
        <BookingListBottom
            v-show="status=='noPaid'"
            :selectedBooking="selectedBooking"
            :selectedOpenBooking="selectedOpenBooking"
        />

      </div>
    </div>
    <Pagination
        :config="paginationConfig"
        v-on:changeCurrentPage="onPaginationChange"
    />

    <ConnectRoomPopup
        :isShow="isShowConnectRoomPopup"
        v-on:onModalClose="isShowConnectRoomPopup=false"
    />

    <QiaohuPopup
        :isShow="isShowQiaohuPopup"
        :shipCode="targetShipCode"
        :sailDate="targetSailDate"
        v-on:onModalClose="isShowQiaohuPopup=false"
    />

    <StarrySkyPopup
        :isShow="isShowStarrySkyPopup"
        :shipCode="targetShipCode"
        :sailDate="targetSailDate"
        v-on:onModalClose="isShowStarrySkyPopup=false"
    />

    <CustomThemePopup
      :isShow="isShowCustomThemePopup"
      :themeInfo="customThemeInfo"
      v-on:onModalClose="isShowCustomThemePopup=false"
    />

    <InvoicePopup v-if="isShowInvoiceList"
                  popup-title="请选择合并开票的订单"
                  @closePopup="isShowInvoiceList=false"
    >
      <div class="invoice-list">
        <div class="list-con">
          <div class="invoice-list-item" v-for="(i,idx) in invoiceBookingList" :key="idx">
            <div class="item-header">
              <RcclCheckBox :defaultChecked="isInvoiceSelected(i.bookingRecordId)" v-on:onChanged="onSelectInvoice(i.bookingRecordId)" />
              <div class="header-info"><span>船票预订号：</span>{{i.bookingId}}<span style="margin-left: 17px">|</span> <span>乘客：</span> {{ i.gusetsNameStr.join(',') }}</div>
            </div>
            <div class="item-main">
              <div class="main-left">
                <div class="main-left-name">{{ i.cruiseRoute }}</div>
                <div class="main-small-text">{{i.shipName}}  {{i.routeNights}}</div>
              </div>
              <div class="main-center main-small-text">
                <div>{{getDateRange(i.sailDate)}}</div>
                <img src="https://resource.rcclchina.com.cn/invoice/toFrom.png" alt="">
                <div>{{getDateRange(i.sailReturnDate)}}</div>
              </div>
              <div class="main-right">
                {{i.currencyIcon}}{{i.amount}}
              </div>
            </div>
          </div>
        </div>
        <div class="invoice-list-footer">
          <div class="footer-right-btn" @click="goInvoicePage">
            开票
          </div>
        </div>
        <div class="invoiceTips" v-show="isShowInvoiceTips">
          请勾选合并开票的订单
        </div>
      </div>
    </InvoicePopup>
    <StateRoomQrCodePopup v-if="isShowWxQrCodePopup"
                          :wxQrCodeUrl="wxQrCodeUrl"
                          @closePopup="closeWxQrCodePopup"
    ></StateRoomQrCodePopup>
  </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
import bookingStatusHelper from '@/utilities/bookingStatusHelper'
import StarrySkyPopup from "@/components/Cruise/CruiseDetail/StarrySkyPopup.vue";
import InvoicePopup from "@/components/Alert/InvoicePopup.vue";
import RcclCheckBox from "@/components/Common/RcclCheckBox.vue";
import StateRoomQrCodePopup from "@/components/Booking/StateRoomQrCodePopup.vue";
import CustomThemePopup from "@/components/Cruise/CruiseDetail/CustomThemePopup.vue";
const Pagination = () => import('@/components/Common/Pagination.vue')
const BookingListItem = () => import('@/components/Booking/BookingList/BookingListItem.vue')
const BookingListBottom = () => import('@/components/Booking/BookingList/BookingListBottom.vue')
const ConnectRoomPopup = () => import('@/components/Cruise/CruiseDetail/ConnectRoomPopup')
const QiaohuPopup = () => import('@/components/Cruise/CruiseDetail/QiaohuPopup')
export default {
  name: "BookingList",
  components: {
    CustomThemePopup,
    RcclCheckBox,
    InvoicePopup,
    StateRoomQrCodePopup,
    StarrySkyPopup,
    Pagination,
    ConnectRoomPopup,
    QiaohuPopup,
    BookingListItem,
    BookingListBottom
  },
  data () {
    return {
      searchBookingId: "",
      pageData: {
        all: [],
        noPaid: [],
        paid: []
      },
      offset: 0,
      limit: 6,
      selectedBooking: [],
      selectedOpenBooking: [],
      targetShipCode: '',
      targetSailDate: '',
      status: 'all',
      isFinishLoading: false,
      isShowQiaohuPopup: false,
      isShowStarrySkyPopup: false,
      isShowConnectRoomPopup: false,
      allowUseTikTokCode: false,
      isShowInvoiceList:false,
      bookingRecordIds:[],
      invoiceBookingList:null,
      isShowInvoiceTips:false, // 显示合并开票的提示
      isShowWxQrCodePopup:false,
      wxQrCodeUrl:'',
      isShowCustomThemePopup: false,
      customThemeInfo: null
    }
  },
  beforeMount () {
    this.initPage()
  },
  methods: {
    async initPage () {
      const userToken = this.$store.state.user.userToken
      if (!userToken || userToken.length == 0) {
        return this.$router.push({ name: 'Login', query:{
            returnUrl: encodeURIComponent(location.href)
          }})
      }
      const storedBookingList = this.$store.state.booking.bookingList
      if (storedBookingList) {
        this.getBookingListSuccessHandler(storedBookingList)
        this.isFinishLoading = true
      } else {
        this.$loading.show()
        const { success, data, errMsg } = await api.booking.bookingList({
          offset: 0,
          limit: 100
        })
        this.$loading.hide()
        if (!success) {
          this.$alert.show(errMsg)
          return
        }
        if (data && data.userCenterBookings) {
          this.getBookingListSuccessHandler(data.userCenterBookings)
          this.$store.commit('SET_BOOKING_LIST', data.userCenterBookings)
          this.isFinishLoading = true
        }
      }
    },
    getBookingListSuccessHandler (bookingList) {
      const bookingItems = this.getBookingItems(bookingList)
      this.pageData = {
        all: this.getBookingsByStatus('all', bookingItems),
        noPaid: this.getBookingsByStatus('noPaid', bookingItems),
        paid: this.getBookingsByStatus('paid', bookingItems)
      }
    },
    getBookingItems (bookingList) {
      let items = []
      bookingList.forEach(order => {
        if (order.bookingItems) {
          order.bookingItems.forEach(item => {
            items.push(item)
          })
        }
      })
      return items
    },
    // 根据状态获取订单
    // staus: all, noPaid, paid
    getBookingsByStatus(status, bookingItems) {
      if (status == 'all') {
        return bookingItems
      } else {
        this.$loading.show()
        const curDate = new Date()
        let statusList = []
        if (status == 'noPaid') {
          statusList = ['unpaid', 'unpaidFull']
        } else if (status == 'paid') {
          statusList = ['paid', 'hasComment', 'noComment', 'confirmed']
        }

        let items = []
        bookingItems.forEach((booking) => {
          const bookingStatus = bookingStatusHelper.getBookingStatus(booking)
          if (statusList.indexOf(bookingStatus) >= 0) {
            if (bookingStatus == 'unpaid' || bookingStatus == 'unpaidFull') {
              const sailDate = new Date(booking.sailDate)
              const openBookingEndDate = new Date(booking.openBookingEndDate)
              if (((booking.openBookingOrderId && booking.openBookingOrderId.length > 0 && openBookingEndDate > curDate)
                  || sailDate > curDate)) {
                items.push(booking)
              }
            } else {
              items.push(booking)
            }
          }
        })
        this.$loading.hide()
        return items
      }
    },
    onTabChanged (status) {
      this.status = status
      this.offset = 0
    },
    onBookingSelected (booking) {
      if (this.selectedBooking.some(r=>r.bookingRecordId == booking.bookingRecordId)) {
        // 反选
        this.selectedBooking = this.selectedBooking.filter(r=>r.bookingRecordId != booking.bookingRecordId)
      } else {
        const status = bookingStatusHelper.getBookingStatus(booking)
        if (status == 'unpaid' || status == 'unpaidFull') {
          this.selectedBooking.push(booking)
          this.selectedOpenBooking = []
        }else if(booking.invoiceStatus===2){
          this.selectedBooking.push(booking)
          this.selectedOpenBooking = []
        }
        let count = 0;
        this.selectedBooking && this.selectedBooking.forEach((row)=> {
          if(row.tikTokCouponStatus === 1 || row.tikTokCouponStatus === 3) {
            count++;
          }
        });
        this.allowUseTikTokCode = count > 0;
      }
    },
    onOpenBookingSelected (booking) {
      // opbk目前只支持单选，不支持多选
      if (this.selectedOpenBooking.length > 0
          && this.selectedOpenBooking[0].openBookingOrderId == booking.openBookingOrderId) {
        this.selectedOpenBooking = []
      } else {
        this.selectedOpenBooking = [booking]
      }
      this.selectedBooking = []
    },
    showQiaohuPopup (booking) {
      this.targetShipCode= booking.shipCode
      let sailDate = booking.sailDate
      if (sailDate.length > 10) {
        sailDate = sailDate.substring(0, 10)
      }
      this.targetSailDate = sailDate
      this.isShowQiaohuPopup = true
    },
    showStarrySkyPopup (booking) {
      this.targetShipCode= booking.shipCode
      let sailDate = booking.sailDate
      if (sailDate.length > 10) {
        sailDate = sailDate.substring(0, 10)
      }
      this.targetSailDate = sailDate
      this.isShowStarrySkyPopup = true
    },
    showCustomThemePopup (val) {
      this.customThemeInfo = val;
      this.isShowCustomThemePopup = true
    },
    showConnectRoom () {
      this.isShowConnectRoomPopup = true
    },
    onSearchBookingChanged () {
      this.searchBookingId = this.$refs.searchBookingIdInput.value
    },
    onPaginationChange(page) {
      const offset = (page - 1) * this.limit
      if (offset != this.offset) {
        this.offset = offset
      }
    },
    showInvoiceList(booking){
      console.log(booking)
      this.bookingRecordIds.push(booking.bookingRecordId)
      this.getInvoiceList()
      this.isShowInvoiceList = true
    },
    // 获取可开发票列表
    async getInvoiceList() {
      if(this.invoiceBookingList&&this.invoiceBookingList.length>0)return
      this.$loading.show()
      let {data, success} = await api.booking.getInvoiceBookingList({userName:this.$store.state.user.userToken})
      this.$loading.hide()
      if(success){
        if(data){
          data.forEach(item=>{
            let gusetsName = []
            item.guests.forEach(guest=>{
              gusetsName.push(guest.guestName)
            })
            item.gusetsNameStr = gusetsName
          })
          this.invoiceBookingList = data
        }
      }
    },
    async showWxQrCode(booking) {
      let params = {
        bookingRecordId:booking.bookingRecordId
      }
      this.$loading.show()
      const {success, data, errMsg} = await api.booking.getWxQrCode(params)
      this.$loading.hide()
      if(success){
        this.wxQrCodeUrl = data
        this.isShowWxQrCodePopup = true
      }else{
        this.$alert.show(errMsg)
      }
    },
    // 是否选中当前发票
    isInvoiceSelected(bookingRecordId){
      return this.bookingRecordIds.some(r=>r===bookingRecordId)
    },
    // 勾选发票
    onSelectInvoice(bookingRecordId){
      if(this.bookingRecordIds.length===0){
        this.bookingRecordIds.push(bookingRecordId)
      }else{
        this.bookingRecordIds.forEach(item=>{
          if(item===bookingRecordId){
            this.bookingRecordIds.splice(this.bookingRecordIds.indexOf(item),1)
          }else{
            this.bookingRecordIds.push(bookingRecordId)
          }
        })
      }
    },
    goInvoicePage(){
      if(this.isShowInvoiceTips) return
      if(this.bookingRecordIds.length<1){
        this.isShowInvoiceTips = true
        setTimeout(()=>{
          this.isShowInvoiceTips = false
        },1500)
      }else{
        this.$router.push({
          path: '/Rccl.Booking/Booking/InvoiceDetails',
          query: {
            bookingRecordIds:this.bookingRecordIds.join(',')
          }
        })
      }
    },
    getDateRange(dateTimeString) {
      let date = new Date(dateTimeString);
      let year = date.getFullYear();
      let month = String(date.getMonth() + 1).padStart(2, '0');
      let day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    },
    closeWxQrCodePopup(){
      this.wxQrCodeUrl = ''
      this.isShowWxQrCodePopup = false
    }
  },
  computed: {
    isShowBottomBar () {
      return (this.selectedBooking.length > 0 || this.selectedOpenBooking.length > 0)
          && (this.status == 'all' || this.status == 'noPaid')
    },
    currentStatusBooking () {
      let bookings = []
      if (this.status == 'all') bookings = this.pageData.all
      else if (this.status == 'noPaid') bookings = this.pageData.noPaid
      else if (this.status == 'paid') bookings = this.pageData.paid

      if (bookings.length == 0) return bookings

      if (this.searchBookingId && this.searchBookingId.length > 0) {
        bookings = bookings.filter(r=>r.bookingId && r.bookingId.indexOf(this.searchBookingId.trim())>=0)
      }

      return bookings
    },
    currentBookings () {
      let bookings = _.slice(this.currentStatusBooking, this.offset, this.limit + this.offset)
      if(bookings.length>0){
          let allowInvoiceStatus = [1,3,4,6]
          bookings && bookings.forEach((row)=> {
            row.showInvoiceLink = allowInvoiceStatus.includes(row.invoiceStatus);
          })
      }
      return bookings
    },
    paginationConfig () {
      const currentPage = parseInt((this.offset) / this.limit) + 1;
      const allPage = parseInt((this.currentStatusBooking.length - 1) / this.limit) + 1;
      return {
        pageSize: this.limit,     //一页的数据条数
        pageNo: currentPage,        //当前页的索引
        total: this.currentStatusBooking.length,         //总的数据条数
        pageTotal: allPage      //总的页数
      }
    },
  }
}
</script>

<style lang="less" scoped>
.center_conten {
  margin: 20px 0;
  min-height: 200px;
  .per_or_head_con {
    height: 55px;
    position: relative;
    font-weight: 400;
    .nav-tabs {
      float: left;
      border: none;
      margin-bottom: -1px;
      li {
        float: left;
        margin-bottom: -1px;
        position: relative;
        display: block;
        a {
          line-height: 1.42857143 !important;
          padding: 17px 32px !important;
          width: 166px !important;
          border: solid 1px #d3dadd;
          text-align: center;
          border-radius: 0;
          background-color: #f3f6f8;
          margin: 0px;
          border-right: none;
          color: #282b2c;
          border-bottom: none;
        }
      }
      li.active {
        a {
          background: #fff;
          color: #006ab9;
        }
        a:after {
          content: '';
          display: block;
          height: 4px;
          background-color: #006ab9;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
        }
      }
      li:last-child > a {
        border: solid 1px #d3dadd;
        position: relative;
        border-bottom: none;
        >.active {
          display: block;
        }
      }
    }

    .searchTooltip {
      float: right;
      top: 20px;
      margin-left: 10px;
      position: relative;
      cursor: pointer;
    }
    .fav_search_con {
      float: right;
      width: 247px;
      height: 36px;
      background-color: #ffffff;
      border: solid 1px #d3dadd;
      margin-top: 12px;
      .fav_input {
        float: left;
        border: none;
        height: 32px;
        margin: 1px 0;
        font-style: normal;
        padding-left: 8px;
        &::placeholder {
          color: #919b9f;
        }
      }
      .search_icon {
        float: right;
        width: 24px;
        height: 23px;
        margin-top: 6px;
        margin-right: 8px;
        cursor: pointer;
      }
    }
    &::after {
      content: '';
      clear: both;
    }
  }
  .tab-content {
    background-color: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(46, 65, 80, 0.11);
    border: solid 1px #d3dadd;
    min-height: 300px;
    padding: 30px;
    padding: 0 !important;
    margin-top: -1px;
    >.active {
      display: block;
    }
  }
  .ord_stu_con {
    overflow: hidden;
    padding: 13px 20px 10px;
    font-weight: 400;
    position: relative;
    .stu_btn {
      float: left;
      min-width: 104px;
      padding: 5px 20px;
      background-color: #eff2f5;
      color: #282b2c;
      margin-right: 20px;
      text-align: center;
      border-radius: 26px;
      position: relative;
      font-size: 14px;
      cursor: pointer;
      i {
        position: absolute;
        right: 2px;
        top: 7px;
        width: 15px;
        height: 15px;
        line-height: 15px;
        background-color: #ff3022;
        border-radius: 19px;
        font-size: 12px;
        color: #fff;
      }
    }
    .stu_btn.checked {
      background-color: #006ab9;
      color: #fff;
    }
    .stu_tip {
      position: absolute;
      top: 10px;
      right: 10px;
      height: 53px;
      line-height: 1;
      font-size: 16px;
    }
    .stu_tip p{
      margin-bottom: 0;
      text-align: right;
    }
    .stu_tip_small{
      font-size: 12px;
      margin-top: 5px;
    }
  }
  .ord_title_con {
    overflow: hidden;
    width: calc(100% - 1px);
    height: 36px;
    margin-left: 1px;
    background-color: #f5f5f5;
    font-weight: 400;
    .line_w {
      width: 279px;
    }
    .passengers_w {
      width: 180px;
    }
    .ship_w {
      margin-left: 20px;
      width: 188px;
    }
    .money_w {
      width: 128px;
    }
    .operation_w {
      width: 140px;
      text-align: right;
    }
    .ord_title {
      float: left;
      padding-left: 20px;
      color: #282b2c;
      height: 36px;
      line-height: 36px;
    }
  }

  .no_booking_tips {
    text-align: center;
    font-size: 18px;
    position: relative;
    top: 90px;
  }

}
.center_conten.personal_order {
  margin-right: 0;
  .pagination-con {
    float: left;
  }
}
.invoice-list{
  padding: 12px 20px 0;
  position: relative;
  .list-con{
    max-height: 350px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .invoice-list-item{
    box-sizing: border-box;
    margin-bottom: 11px;
    .item-header{
      display: flex;
      align-items: center;
      height: 30px;
      background-color: #f5f5f5;
      gap: 10px;
      padding: 9px 13px;
      .header-info{
        color: #333333;
        font-size: 16px;
        span{
          color: #93989a;
        }
      }
    }
    .item-main{
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #333333;
      padding: 16px 13px 10px;
      border-bottom: 1px #d9d9d9 solid;
      .main-left{
          width: 210px;
        .main-left-name{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .main-center{
        margin: 0 100px 0 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
      .main-right{
        color: #ea3b28;
        font-weight: bold;
      }
      .main-small-text{
        font-size: 14px;
        color: #848a8d;
      }
    }
  }
  .invoice-list-footer{
    display: flex;
    align-items: center;
    gap: 63px;
    justify-content: center;
    margin-top: 30px;
    div{
      width: 265px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #333333;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      border-radius: 4px;
    }
    .footer-left-btn{
      background-color: #f5f5f5;
    }
    .footer-right-btn{
      background: linear-gradient(225deg, #fcbf00, #ffdb17);
    }
  }
  .invoiceTips{
    width: 318px;
    height: 64px;
    background-color: rgba(32, 32, 32, 0.58);
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    color: #ffffff;
    font-size: 18px;
    text-align: center;
    line-height: 64px;
  }
}
</style>

<style lang="less">
.per_or_head_con {
  .tooltip-inner {
    min-width: 370px;
    background-color: #54a3de;
    color: #fff;
    text-align: left;
    padding: 8px 10px;
    opacity: 1;
    border: 1px solid #54a3de;
  }
  .tooltip.top .tooltip-arrow {
    border-top-color: #54a3de;
  }
  .tooltip {
    left: -134px !important;
  }
}
.privacy-layout {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
